<div #content
     id="account-setup-loc-agreement"
     class="layout"
     [innerHtml]="safeHtml"></div>

<section *ngIf="unplacedDisclosures.length">
  <ifp-agreement-disclosure *ngFor="let disclosure of unplacedDisclosures; trackBy: trackByCode"
                            [attr.id]="disclosure.code"
                            [disclosure]="disclosure"
                            [signerInitials]="signerInitials"
                            [acceptGuard]="acceptGuard"
                            [position]="positions[disclosure.code]"
                            [total]="disclosures?.length"
                            (accepted)="onAccepted($event)"
                            (popupOpened)="onPopupOpened($event)"></ifp-agreement-disclosure>
</section>

<mat-error *ngIf="missingPlacement"
           class="agreement-document__error">
  This agreement cannot be accepted yet because one of its disclosures is missing. Please reload the page, or contact your business advisor.
</mat-error>
